import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const VendorAppointments = () => {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [richTextMap, setRichTextMap] = useState({});
  const [customerNames, setCustomerNames] = useState({});
  const navigate = useNavigate();
  const location = useLocation();

  // Get user_id from logged in user
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const user_id = user.id;

  // Get status param from URL
  const searchParams = new URLSearchParams(location.search);
  const statusParam = searchParams.get('status');

  function handleStatusChange(appointmentId, newStatus) {
   
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/vendor_appointments/${appointmentId}/status`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status: newStatus }),
    })
      .then(res => res.json())
      .then(() => {
        setAppointments(prev =>
          prev.map(app =>
            app.id === appointmentId ? { ...app, status: newStatus } : app
          )
        );
      });
  }

  const handleRichTextChange = (appointmentId, value) => {
    setRichTextMap(prev => ({
      ...prev,
      [appointmentId]: value,
    }));
    // Optionally, you can send this to the backend here
  };

  useEffect(() => {
    if (!user_id) return;
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/vendor_appointments?user_id=${user_id}`)
      .then(res => res.json())
      .then(data => {
        // Sort appointments by creation_date in descending order
        const sortedAppointments = (data.appointments || []).sort((a, b) => {
          return new Date(b.creation_date) - new Date(a.creation_date);
        });
        
        setAppointments(sortedAppointments);
        setLoading(false);

        // Fetch customer names for all unique customer_ids
        const customerIds = Array.from(new Set(sortedAppointments.map(app => app.customer_id)));
        if (customerIds.length > 0) {
          // Look up customer names from the users table based on customer_id
          fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/customers_by_ids`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ids: customerIds }),
          })
            .then(res => res.json())
            .then(data => {
              // data.customers should be an array of { id, firstName, lastName }
              const namesMap = {};
              (data.customers || []).forEach(c => {
                namesMap[c.id] = `${c.firstName} ${c.lastName}`;
              });
              setCustomerNames(namesMap);
            });
        }
      });
  }, [user_id]);

  if (loading) return <div style={styles.container}>Loading appointments...</div>;

  // Filter appointments by status if statusParam is present
  const filteredAppointments =
    statusParam === 'pending'
      ? appointments.filter(app => app.status === 'pending')
      : statusParam === 'accepted'
      ? appointments.filter(app => app.status === 'accepted')
      : statusParam === 'rejected'
      ? appointments.filter(app => app.status === 'rejected')
       : statusParam === 'completed'
      ? appointments.filter(app => app.status === 'completed')
      : appointments;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Your Appointments</h2>
      <button
        style={styles.backBtn}
        onClick={() => navigate('/vendordashboard')}
      >
        &#8592; Back to Coach Dashboard
      </button>
      {filteredAppointments.length === 0 ? (
        <div style={styles.empty}>No appointments found.</div>
      ) : (
        <div style={styles.cardGrid}>
          {filteredAppointments.map(app => (
            <div key={app.id} style={{
              ...styles.card,
              background: app.status === 'pending' ? '#fff3e0' : '#f5f6fa',
              border: app.status === 'pending' ? '2px solid #ff9800' : '2px solid #e0cfa0',
              boxShadow: app.status === 'pending'
                ? '0 2px 16px #ffcc80'
                : '0 1px 8px #e0cfa0',
              position: 'relative',
              minHeight: '340px',
              padding: '38px 32px 32px 32px',
            }}>
              {/* Customer Name Row */}
              <div style={styles.cardRow}>
                <span style={styles.label}>Customer:</span>
                <span style={styles.value}>
                  {customerNames[app.customer_id] || app.customer_id}
                </span>
              </div>
              <div style={styles.cardRow}>
                <span style={styles.label}>Date:</span>
                <span style={styles.value}>
                  {app.date
                    ? (() => {
                        const d = new Date(app.date);
                        const mm = String(d.getMonth() + 1).padStart(2, '0');
                        const dd = String(d.getDate()).padStart(2, '0');
                        const yyyy = d.getFullYear();
                        return `${mm}/${dd}/${yyyy}`;
                      })()
                    : ''}
                </span>
              </div>
              <div style={styles.cardRow}>
                <span style={styles.label}>Start Time:</span>
                <span style={styles.value}>{app.start_time}</span>
              </div>
              <div style={styles.cardRow}>
                <span style={styles.label}>End Time:</span>
                <span style={styles.value}>{app.end_time}</span>
              </div>
              <div style={styles.cardRow}>
                <span style={styles.label}>Notes:</span>
                <span style={styles.value}>{app.notes}</span>
              </div>
              
              {/* Add a break/spacing between Notes and Conference Info */}
              <div style={{ height: '16px' }}></div>
              
              <div style={styles.cardRow}>
                <span style={styles.label}>Conference Info:(Please add your zoom or any other video conferencing links here, before you can accept the customers request)</span>
           
              
              </div>
                <div style={styles.cardRow}>
                <span style={styles.value}>
                  {app.appointment_links !== ' '
                    ? <div style={styles.largeLink} dangerouslySetInnerHTML={{ __html: app.appointment_links }} />
                    : <span style={{ color: '#888' }}>No link provided</span>
                  }
                </span>
                  </div>
              <div style={styles.cardRow}>
                <span style={styles.label}>Status:</span>
                <span style={{
                  ...styles.value,
                  color: app.status === 'pending' ? '#ff9800' : '#388e3c',
                  fontWeight: 'bold'
                }}>
                  {app.status.charAt(0).toUpperCase() + app.status.slice(1)}
                </span>
              </div>
              <button
                style={styles.linkBtn}
                onClick={() => navigate(`/appointmentlinks?id=${app.id}`)}
              >
                {(!app.appointment_links || app.appointment_links.trim() === '') ? 'Add Zoom Link' : 'Edit Zoom Link'}
              </button>
              {app.status === 'pending' && (
                <div style={styles.buttonRow}>
                  <button
                    style={{
                      ...styles.acceptBtn,
                      background: (!app.appointment_links || app.appointment_links.trim() === '') ? '#bdbdbd' : styles.acceptBtn.background,
                      cursor: (!app.appointment_links || app.appointment_links.trim() === '') ? 'not-allowed' : 'pointer',
                    }}
                    disabled={!app.appointment_links || app.appointment_links.trim() === ''}
                    onClick={() => {
                      if (window.confirm('Are you sure you want to accept this appointment?')) {
                        handleStatusChange(app.id, 'accepted');
                      }
                    }}
                  >
                    Accept
                  </button>
                  <button
                    style={{
                      ...styles.rejectBtn,
                      background: app.appointment_links === ' ' ? '#bdbdbd' : styles.rejectBtn.background,
                      cursor: app.appointment_links === ' ' ? 'not-allowed' : 'pointer',
                    }}
                    disabled={app.appointment_links === ' '}
                    onClick={() => {
                      if (window.confirm('Are you sure you want to reject this appointment?')) {
                        handleStatusChange(app.id, 'rejected');
                      }
                    }}
                  >
                    Reject
                  </button>
                </div>
              )}
              { <span style={styles.label}>Click on the Mark as Completed button only for accepted appointments that have passed the appointment date/time</span>}
              {app.status === 'accepted' && (
                <div style={styles.buttonRow}>
                  <button
                    style={{
                      ...styles.acceptBtn,
                      background: '#4acd4cff',
                      color: '#fff',
                    }}
                    onClick={() => {
                      if (window.confirm('Mark this appointment as completed?')) {
                        handleStatusChange(app.id, 'completed');
                      }
                    }}
                  >
                   Mark as Completed
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '1350px', // Increased width by 50% from 900px
    margin: '40px auto',
    padding: '32px',
    background: '#fff',
    borderRadius: '14px',
    boxShadow: '0 4px 24px rgba(141,110,54,0.10)',
  },
  title: {
    marginBottom: '28px',
    color: '#8d6e36',
    fontSize: '1.7rem',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '1px',
  },
  empty: {
    textAlign: 'center',
    color: '#888',
    fontSize: '1.1rem',
    marginTop: '32px',
    fontStyle: 'italic',
  },
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
    gap: '28px',
    marginTop: '12px',
    width: '100%', // Make the card grid as wide as the container
  },
  card: {
    background: '#f5f6fa',
    borderRadius: '14px',
    padding: '28px 22px 22px 22px',
    boxShadow: '0 1px 8px #e0cfa0',
    minHeight: '180px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    border: '2px solid #e0cfa0',
    transition: 'box-shadow 0.2s, border 0.2s, background 0.2s',
    position: 'relative',
    minHeight: '340px',
    padding: '38px 32px 32px 32px',
  },
  pendingBox: {
    position: 'absolute',
    top: '-18px', // Move it higher above the card
    right: '18px',
    background: '#ff9800',
    color: '#fff',
    fontWeight: 'bold',
    borderRadius: '8px',
    padding: '8px 22px',
    fontSize: '1.08rem',
    boxShadow: '0 1px 4px #ffcc80',
    letterSpacing: '1px',
    textAlign: 'center',
    border: '2px solid #fff3e0',
    zIndex: 2,
  },
  cardRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
    paddingBottom: '2px',
    borderBottom: '1px solid #f0e6d2',
  },
  label: {
    fontWeight: 'bold',
    color: '#8d6e36',
    fontSize: '1.08rem',
    letterSpacing: '0.5px',
  },
  value: {
    color: '#4078c0',
    fontSize: '1.08rem',
    fontWeight: 'bold',
    marginLeft: '12px',
    textAlign: 'right',
    wordBreak: 'break-word',
  },
  richTextRow: {
    margin: '12px 0 0 0',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  richTextLabel: {
    fontWeight: 'bold',
    color: '#8d6e36',
    fontSize: '1.05rem',
    marginBottom: '2px',
  },
  richTextBox: {
    width: '100%',
    minHeight: '80px',
    marginBottom: '8px',
    borderRadius: '8px',
    border: '1px solid #e0cfa0',
    padding: '10px',
    fontSize: '1rem',
    resize: 'vertical',
    background: '#fff',
    color: '#333',
    fontFamily: 'inherit',
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'center',
    gap: '18px',
    marginTop: '18px',
  },
  acceptBtn: {
    background: '#388e3c',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '8px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #c8e6c9',
    transition: 'background 0.2s',
  },
  rejectBtn: {
    background: '#d32f2f',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '8px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #ffcdd2',
    transition: 'background 0.2s',
  },
  linkBtn: {
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '8px 18px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #e0cfa0',
    transition: 'background 0.2s',
    marginTop: '8px',
    alignSelf: 'flex-end',
    textDecoration: 'none',
  },
  largeLink: {
    display: 'block',
    background: '#f9fbe7',
    borderRadius: '8px',
    padding: '14px',
    fontSize: '1.12rem',
    color: '#333',
    minHeight: '80px',
    maxHeight: '220px',
    overflowY: 'auto',
    marginTop: '6px',
    marginBottom: '6px',
    wordBreak: 'break-word',
  },
  backBtn: {
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '8px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #e0cfa0',
    transition: 'background 0.2s',
    textDecoration: 'none',
    marginBottom: '24px',
    marginRight: 'auto',
    display: 'block',
  },
};

export default VendorAppointments;